import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthModule } from '../modules/auth/auth.module';
import { HttpClientModule } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RangeSliderModule } from '../modules/range-slider/range-slider.module';
import { MapPipe } from "./pipes/map.pipe";
import { TypeofPipe } from "./pipes/typeof.pipe";
import { SmartDatePipe } from "./pipes/smart-date.pipe";
import { MatSelectModule } from '@angular/material/select';
import { ContactUsComponent } from './components/contact-us/contact-us.component';



@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        SideBarComponent,
        MapPipe,
        TypeofPipe,
        SmartDatePipe,
        ContactUsComponent,
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AuthModule,
        CarouselModule,
        RangeSliderModule,
        MatSelectModule

    ],
    exports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HeaderComponent,
        SideBarComponent,
        FooterComponent,
        CarouselModule,
        RangeSliderModule,
        MapPipe,
        TypeofPipe,
        SmartDatePipe,
        MatSelectModule

    ]
})
export class SharedModule { }